import { Panel, PanelState } from '@foradevelopment/fora-ui';
import { EmploymentViewModelNew } from '@fora-monorepo/employer-my-pages-common/types';

import { useTypedTranslation } from '../../../i18n/i18n';
import { AddEmployeeWizard } from '../../Wizard/AddEmployeeWizard';

export const AddEmployeePanel = ({
  panelState,
  goToNextPanel,
}: {
  panelState: PanelState;
  goToNextPanel: (employment: EmploymentViewModelNew) => void;
}) => {
  const { t } = useTypedTranslation();

  return (
    <Panel testId="test-panel-add-employment" name="panel-add-employment" {...panelState}>
      <Panel.Header marginTop="0px">{t('panel.addEmployee.panelTitle')}</Panel.Header>
      <Panel.Body>
        <AddEmployeeWizard goToNextPanel={goToNextPanel} />
      </Panel.Body>
    </Panel>
  );
};
